import axios from 'axios'
import React, { useState, useEffect } from 'react'
import { ToastContainer } from 'react-toastify'
import { BASE_URL } from '../../config/axios'
import { AddActivity, UpdateActivity, DeleteActivity } from './AddActivity';




const Activtiy = () => {
  const [Activity, setActivity] = useState([]);

  const getActivity = async () => {
    try {
      const result = await axios.get(`${BASE_URL}/detail-design/activity/`);
      console.log(result, 'activity')
      setActivity(result.data);
    } catch (err) {
      console.error("Error fetching sub-activities:", err);
    }
  };

  useEffect(() => {
    getActivity();
  }, []);

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="content-tabs">
        <div className="attendance-box">
          <div className="attendance-subcont-01">
            <div className="field-cont">
              <div className="field-cont-div"></div>
            </div>

            <div className="btn-cont">
              <AddActivity getActivity={getActivity} />
            </div>
          </div>

          <div className="datagrid-container">
            <div className="table-css-white-background table-box scroll-container-table">
              <table className="table-css">
                <thead className="table-heading">
                  <tr className="custom-table-head-tr">
                    <th className="table-heading-text">Sr no.</th>
                    <th className="table-heading-text text-center" style={{ padding: "30px 70px" }}>
                      Activity Code
                    </th>
                    <th className="table-heading-text text-center" style={{ padding: "30px 70px" }}>
                      Activity Name
                    </th>
                    <th className="table-heading-text text-center" style={{ padding: "30px 70px" }}>
                      Sub_activity Name
                    </th>
                    <th className="table-heading-text text-end" style={{ paddingRight: '50px' }}>
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {Activity.length > 0 ? (
                    Activity.map((i, index) => (
                      <tr key={i.id || index} className="custom-table-head-td">
                        <td className="table-body">{index + 1}</td>
                        <td className="table-body text-center">{i.activity_code}</td>
                        <td className="table-body text-center">{i.activity_name}</td>
                        <td className="table-body text-center">
                          {Array.isArray(i.subactivities) && i.subactivities.length > 0 ? (
                            i.subactivities.map((sub, idx) => (
                              <div key={sub.id || idx}>{sub.subactivity_name}</div>
                            ))
                          ) : (
                            "No Sub-Activity"
                          )}
                        </td>
                        <td className="table-body text-left">
                          <div className="flex-row" style={{ justifyContent: 'end' }}>
                            <UpdateActivity i={i} getActivity={getActivity} />
                            <DeleteActivity i={i} getActivity={getActivity}  />
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center">
                        No Sub-Activity Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};




export default Activtiy
